import { Button, COLOR_PALETTE, Group, Icon, OptimizeImage, Text } from '@inflearn/ds-react-next';
import { KoOnly } from '@inflearn/i18n-tools';
import { faChevronRight } from '@inflearn/pro-solid-svg-icons';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { MY_URL } from '../../../../constants/urls';

const SLOT_SAMPLE_IMAGE_PATHS = Array.from(
  { length: 5 },
  (_, i) =>
    `${process.env.NEXT_PUBLIC_CDN_URL}/public/games/slot_sample_${String(i + 1).padStart(2, '0')}.png`,
);

export const ProfileSlotGameButton = () => {
  const router = useRouter();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % SLOT_SAMPLE_IMAGE_PATHS.length);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    router.push(MY_URL.GAMES());
  };

  return (
    <KoOnly>
      <Button
        w={170}
        h={42}
        color="gray"
        variant="subtle"
        size="compact-sm"
        onClick={handleClick}
        rightSection={<Icon icon={faChevronRight} size="xs" color="infgreen.7" />}
        styles={{
          root: {
            backgroundColor: COLOR_PALETTE.gray[0],
            '&:hover': {
              backgroundColor: COLOR_PALETTE.gray[1],
            },
            '@media(max-width: 1200px)': {
              display: 'none !important',
            },
          },
        }}
      >
        <Group gap={8} align="center">
          <OptimizeImage
            src={SLOT_SAMPLE_IMAGE_PATHS[currentImageIndex]}
            alt="slot sample"
            width={30}
            height={30}
            w={30 * 2}
            style={{ display: 'block' }}
          />
          <Text size="sm" fw={700} c="infgreen.7">
            상배 프사 만들기
          </Text>
        </Group>
      </Button>
    </KoOnly>
  );
};
